import styled from "styled-components";

export const MenuItemStyled = styled.button`
  border-bottom: 0.5px solid ${({ theme }) => theme.COLORS.GRAY_12};
  padding: 0px 12.5px;
  background: none;
  cursor: pointer;

  .menu_iteme_icon {
    margin-bottom: 12.5px;
  }
  .menu_item_name {
    margin-bottom: 10px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  }
`;
